import React from "react";
import "../styles/Hero.css";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { AiFillRightCircle } from "react-icons/ai";

const Hero = () => {
  return (
    <>
      <div className="hero-align">
        <StaticImage
          src="../images/Background-pic.jpg"
          className="hero-style"
          alt="omega homepage background picture"
          layout="fullWidth"
          placeholder="tracedSVG"
        />
        <div className="hero-title">
          <h1>Descubre el mundo con Nosotros</h1>
        </div>
      </div>
    </>
  );
};

export default Hero;
